import { useTranslation } from '../hooks/useTranslation'
import type { CartItem } from '../types/display'
import CartItemRow from './CartItemRow'

export default function CartList({ items, currency }: { items: CartItem[]; currency: string }) {
  const { t } = useTranslation()
  // Defensive: RTDB can hand us a sparse/keyed object instead of an array
  // (e.g. after a mid-cart item deletion) even though it's typed as one —
  // never let that reach `.map` and unmount the whole display.
  const list = Array.isArray(items) ? items : []

  if (list.length === 0) {
    return (
      <div className="cart-scroll flex flex-1 flex-col items-center justify-center gap-2.5 overflow-y-auto py-2 text-text-lo">
        <div className="font-volte text-[2.5rem] opacity-25">○</div>
        <div className="text-[2em] uppercase tracking-[0.2em]">{t('no-items-yet')}</div>
      </div>
    )
  }

  return (
    <div className="cart-scroll flex-1 overflow-y-auto py-2">
      {list.map((item, i) => (
        <CartItemRow key={`${item.title}-${i}`} item={item} currency={currency} />
      ))}
    </div>
  )
}
